import React from "react";
import { Button } from "@shared/components/Button";
import { LayerList } from "@shared/Sidebar/LayerList";

interface SidebarDrawerProps {
	onClose: () => void;
}

export const SidebarDrawer: React.FC<SidebarDrawerProps> = (props) => {
	return (
		<div className={"fixed inset-0 z-[100]"} onClick={props.onClose}>
			<div className={"absolute inset-0 bg-black/40"} />
			<div
				className={
					"absolute right-0 top-0 h-full w-[min(100vw,26rem)] max-w-full bg-base-300 border-l border-border-base-200 flex flex-col"
				}
				onClick={(e) => e.stopPropagation()}
			>
				<div
					className={
						"flex items-center justify-between p-2 border-b border-border-base-200"
					}
				>
					<span className={"text-white font-bold"}>Panels</span>
					<Button variant={"ghost"} size={"icon-sm"} onClick={props.onClose}>
						<svg width={18} height={18} viewBox={"0 0 24 24"} fill={"none"}>
							<path
								d={"M6 6l12 12M18 6L6 18"}
								stroke={"currentColor"}
								strokeWidth={2}
								strokeLinecap={"round"}
							/>
						</svg>
					</Button>
				</div>
				<div className={"flex-1 min-h-0"}>
					<LayerList />
				</div>
			</div>
		</div>
	);
};
